"use strict";

import { executeTourAction } from "./UiActionBus";
import { TOUR_IDS } from "./tourIds";
import {
  emitCloseTourTransientUi,
  OPEN_PRESENCE_REPORT_EVENT,
} from "./tourEvents";

/**
 * Clear dialogs / sheets that would cover the next tour highlight.
 * Presence / sidebar stay open when the next step still needs them.
 */
export function closeTourTransientUi(nextStep) {
  const keepsPresence =
    nextStep?.arrive?.panel === "presenceReport" ||
    nextStep?.tourId === TOUR_IDS.adminPresenceBoard;
  if (!keepsPresence && typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent(OPEN_PRESENCE_REPORT_EVENT, { detail: { open: false } })
    );
  }
  const keepsSidebar =
    String(nextStep?.tourId || "").startsWith("admin-nav") ||
    (!nextStep?.closeSidebar && String(nextStep?.navTourId || "").startsWith("admin-nav"));
  if (!keepsSidebar) {
    executeTourAction({ type: "openPanel", panel: "adminSidebar", open: false });
  }

  emitCloseTourTransientUi({
    keep: {
      presence: Boolean(keepsPresence),
      sidebar: Boolean(keepsSidebar),
      playerNewSession: nextStep?.arrive?.panel === "playerNewSession",
      addSession: nextStep?.arrive?.panel === "addSession",
      profileSmart: nextStep?.arrive?.panel === "profileSmart",
    },
  });
}
